import React from 'react';

import { getTableSum } from '../../utility/getTableSum';
import { renderMoneyAmountShort } from '../../components/formBuilder/utility/renderValue';
import ClearBadge from '../../components/property-summaries/ClearBadge';
import OverviewDivider from '../../components/property-summaries/OverviewDivider';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

function calculateTotalRehabCost(
  additionalInvestment,
  totalUnitRehabCosts,
  totalUnitBuyoutCosts,
  enterTotalRentalIncome
) {
  const investmentTotal = getTableSum(
    additionalInvestment,
    'additionalInvestmentValue'
  );

  if (enterTotalRentalIncome) {
    return investmentTotal || 0;
  }

  return (
    (totalUnitRehabCosts || 0) + (totalUnitBuyoutCosts || 0) + investmentTotal
  );
}

export default function RehabSummaryOverview({ propertyData }) {
  const timeToComplete = propertyData.rehabLength;

  const totalRehabCost = calculateTotalRehabCost(
    propertyData.additionalInvestment,
    propertyData.totalUnitRehabCosts,
    propertyData.totalUnitBuyoutCosts,
    propertyData.enterTotalRentalIncome
  );

  const cashflow = propertyData.monthlyPreTaxCashFlowBuyAndHold;

  const propertyValue = propertyData.newMarketValue;
  const propertyValueIncrement =
    propertyData.newMarketValue - propertyData.marketPurchasePrice;

  return (
    <section className="rounded-lg relative bg-white p-4">
      <div className="flex flex-col sm:flex-row relative sm:flex-nowrap items-stretch gap-2 sm:gap-0">
        <div className="flex-grow bg-[#F5F6F4] rounded-lg sm:rounded-r-none sm:rounded-l-lg py-4 px-3 lg:px-6">
          <div className="relative">
            <div
              className="absolute inset-0 flex items-center"
              aria-hidden="true"
            >
              <div className="w-full border-t border-neutral-200"></div>
            </div>
            <div className="relative flex justify-center">
              <span className="bg-[#F5F6F4] px-5 text-md text-neutral-600">
                Rehab Cost
              </span>
            </div>
          </div>
          <div className="px-6 lg:px-12 mt-7 mb-4">
            <div className="flex flex-wrap gap-2">
              <div className="flex-1 flex flex-col justify-center">
                <h4 className="text-[12px] font-normal text-neutral-600">
                  Time to complete
                </h4>
                <p className="text-xl font-serif text-neutral-900 font-medium">
                  {timeToComplete} months
                </p>
              </div>
              <div className="flex-1  flex flex-col justify-center">
                <h4 className="font-normal text-neutral-600 text-md">
                  Total Rehab Costs
                </h4>
                <p className="text-6xl font-serif text-neutral-900 font-medium printing-text-spacing">
                  {renderMoneyAmountShort(totalRehabCost)}
                </p>
              </div>
            </div>
          </div>
        </div>

        <OverviewDivider />
        <div className="flex-grow bg-[#EFF8F3] rounded-lg sm:rounded-l-none sm:rounded-r-lg py-4 px-3 lg:px-6">
          <div className="relative">
            <div
              className="absolute inset-0 flex items-center"
              aria-hidden="true"
            >
              <div className="w-full border-t border-neutral-200"></div>
            </div>
            <div className="relative flex justify-center">
              <span className="bg-[#EFF8F3] text-md px-5 text-neutral-600">
                Post Rehab
              </span>
            </div>
          </div>
          <div className="px-6 lg:px-12 mt-7 mb-4">
            <div className="flex flex-wrap gap-2 justify-center">
              <div className="flex-1 flex flex-col justify-center">
                <Link to="#cash-flow"></Link>
                <HashLink
                  smooth
                  to="#cash-flow"
                  scroll={(el) => {
                    el.scrollIntoView({
                      behavior: 'smooth',
                      block: 'center',
                    });
                  }}
                >
                  <h4 className="font-normal text-neutral-600 hover:underline">
                    Cashflow
                  </h4>
                </HashLink>
                <HashLink
                  smooth
                  to="#cash-flow"
                  scroll={(el) => {
                    el.scrollIntoView({
                      behavior: 'smooth',
                      block: 'center',
                    });
                  }}
                >
                  <p className="text-6xl font-serif text-neutral-900 font-medium printing-text-spacing hover:underline underline-offset-4">
                    {renderMoneyAmountShort(cashflow)}
                    <span className="text-3xl">/mo</span>
                  </p>
                </HashLink>
              </div>
              <div className="flex-1 flex flex-col justify-center">
                <h4 className="font-normal text-neutral-600 text-md">
                  Property Value
                </h4>
                <div className="flex items-center justify-center gap-4 printing-text-spacing">
                  <p className="text-6xl font-serif text-neutral-900 font-medium">
                    {renderMoneyAmountShort(propertyValue)}
                  </p>

                  <ClearBadge amount={propertyValueIncrement}>
                    {renderMoneyAmountShort(propertyValueIncrement, true)}
                  </ClearBadge>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
